<template>
  <el-dialog
    :model-value="visible"
    title="编辑素材标签"
    width="420px"
    :close-on-click-modal="false"
    @update:model-value="$emit('update:visible', $event)"
  >
    <p class="text-sm text-slate-500 mb-3">素材：{{ asset?.name }}</p>
    <el-select v-model="selectedTagIds" multiple placeholder="选择标签" class="w-full" clearable>
      <el-option
        v-for="tag in tagList"
        :key="tag.id"
        :label="tag.name"
        :value="tag.id"
      >
        <span class="inline-block w-2.5 h-2.5 rounded-full mr-1.5" :style="{ backgroundColor: tag.color || '#94a3b8' }"></span>
        {{ tag.name }}
      </el-option>
    </el-select>
    <template #footer>
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">保存</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { updateAssetTags } from '@/api/assets'

const props = defineProps({
  visible: { type: Boolean, default: false },
  asset: { type: Object, default: null },
  tagList: { type: Array, default: () => [] }
})

const emit = defineEmits(['update:visible', 'success'])

const selectedTagIds = ref([])
const submitting = ref(false)

watch(() => props.visible, (val) => {
  if (val && props.asset) {
    selectedTagIds.value = (props.asset.tags || []).map(t => t.id)
  }
})

async function handleSubmit() {
  submitting.value = true
  try {
    await updateAssetTags(props.asset.id, { tagIds: selectedTagIds.value })
    ElMessage.success('标签已更新')
    emit('success')
    emit('update:visible', false)
  } catch {
    // handled by interceptor
  } finally {
    submitting.value = false
  }
}
</script>
